import {Injectable, EventEmitter} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/Rx';

// Services
import {ProductsPackagesService} from './products-packages-service';
import {DynamicPropertiesService} from './dynamic-properties-service';

// Classes
import {Product} from '../classes/product';

// Config
import {CONFIG} from '../../../../config/config';

// Data
import {productOptions} from '../data/product-options';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductsService'));

@Injectable()
export class ProductsService {

    public events = {
        productStateRefreshed: new EventEmitter()
    }

    private _products = [];
    private _catalogService;
    private _imgPaths;
    private _appService;
    
    constructor (
        private _http: Http,
        private _productsPackagesService: ProductsPackagesService,
        private _dynamicPropertiesService: DynamicPropertiesService,
    ) {
        // 'Construct products service' );

        // TODO: Is this the best solution?
        // Provide access to methods from parent service
        this._productsPackagesService.init( this );
        this._dynamicPropertiesService.init( this );
    }

    
    public init (catalogService, AppService) {
        // 'Initialise products service' );
        this._catalogService = catalogService;
        this._appService = AppService;
        this._imgPaths = this._catalogService.imgPaths;
    }

    /** TODO: Secure api
     * REST service method
     */
    public getAllProductsAsync (): Observable<Product[]> {
        // 'Get all products async' );

        let self = this,
            domain = CONFIG.domain,
            observable = this._http.get( domain + 'api/product' )
                .map( res => res.json() )
                .catch( this._handleError );

        // Cache values in service
        observable.subscribe(
            response => {
                self._products = response;
                debugOff( 'Products:', self._products );
            },
            error => console.error( error )
        );

        return observable;
    }

    /** TODO: Secure api
     * REST service method
     */
    public getProductByIdAsync (id): Observable<Product> {
        // 'Get product by id async' );

        let domain = CONFIG.domain;

        return this._http.get( domain + 'api/product/' + id )
            .map( res => res.json() )
            .catch( this._handleError );
    }

    /** TODO: Secure api
     * REST service method
     */
    public saveProductAsync (product) {
        // 'Save product async' );

        let domain = CONFIG.domain;

        if (product.code === 0) {

            // Create new product
            return this._http.post( domain + 'api/product', product )
                .map( res => res.json() )
                .catch( this._handleError );
        } else {

            // Update existing product
            return this._http.put( domain + 'api/product/' + product.code, product )
                .map( res => res.json() )
                .catch( this._handleError );
        }
    }

    /** TODO: Secure api
     * REST service method
     */
    public deleteProductAsync (product) {
        // 'Delete product async' );

        let domain = CONFIG.domain;

        return this._http.delete( 'api/product/' + product.code )
            .map( res => product )
            .catch( this._handleError );
    }

    
    public getProductsList () {
        debugOff( 'Get products list' );
        debugOff( 'Product categories list:', this._products );
        return this._products;
    }

    
    public getProductsByCategoryId (categId) {
        debugOff( 'Get products by "' + categId + '" category id' );

        let products = this._products.filter( (product: Product) => {
            return product.taxonomy !== undefined &&
                product.taxonomy.categories !== undefined &&
                product.taxonomy.categories.indexOf( categId ) !== -1;
        });

        debugOff( 'Products:', products );

        return products;
    };

    
    public getProductById (prodId) {
        debugOff( 'Get product by id  "' + prodId + '"' );

        // Could be improved with binary search and sorted arrays
        let product = this._products.filter( (product: Product) => {
            return product.code === prodId;
        });

        if (product.length > 1) { console.warn( 'Multiple products have "' + prodId + '" id' ); }

        debugOff( 'Product:', product[0] );

        return product[0];
    };

    
    public getProductOptionImage (optionsId, optionId) {
        debugOff( 'Get option image' );

        let imagePath = '';

        if (productOptions[optionsId][optionId] !== undefined) {
            imagePath = this._imgPaths.options + optionsId + '/' + productOptions[optionsId][optionId].image;
        }

        debugOff( 'Image path:', imagePath );

        return imagePath;
    }

    
    public getProductOptionName (optionsId, optionId) {
        debugOff( 'Get option name' );

        let optionName = '';

        if (productOptions[optionsId][optionId] !== undefined) {
            optionName = productOptions[optionsId][optionId].name;
        }

        debugOff( 'Option name:', optionName );

        return optionName;
    }

    
    public initProducts (products: Array<Product>, globals) {
        // 'Initialise products' );

        products.forEach( (product: Product) => {

            // Cache a reference of globals
            // Necessary on certain products for dynamic properties update
            product._globals = globals;
        });
    }

    
    public refreshAllProducts () {
        // 'Refresh all products' );

        this._products.forEach( (product: Product) => {
            product.refreshState();
        });
    }

    
    public appendProductAPI (products: Array<Product>) {
        // 'Append product API' );

        let self = this;

        products.forEach( (product: Product) => {

            
            product.displayTooltip = () => {
                // 'Show tooltip for "' + product.code + '" product' );
                product.tooltipIsVisible = true;

                // Display tooltips for package products
                product.package && product.package.products.forEach( (product: Product) => {
                    debugOff( 'Product:', product );
                    // product.displayTooltip();
                    product.tooltipIsVisible = true;
                });
            };

            
            product.hideTooltip = () => {
                // 'Show tooltip for "' + product.code + '" product' );
                product.tooltipIsVisible = false;

                // Hide tooltips for package products
                product.package && product.package.products.forEach( (product: Product) => {
                    // product.hideTooltip();
                    product.tooltipIsVisible = false;
                });
            };

            
            product.updateDynamicProperties = () => {
                this._dynamicPropertiesService.updateDynamicProperties( product );
            };

            
            product.generatePackageProducts = () => {
                this._productsPackagesService.generatePackageProducts( product );
            };

            
            product.refreshState = () => {
                // '"' + product.code + '" - Refresh product state' );



                                // //product.code, product.optionsSelected);
                // Update dynamic properties
                // product.updateDynamicProperties();
                this._dynamicPropertiesService.updateDynamicProperties( product );

                                // //product.code, product.optionsSelected);
                // Generate package products if package is enabled
                if (product.package !== undefined &&
                    product.package.config !== undefined) {
                    this._productsPackagesService.generatePackageProducts( product );
                }

                this.events.productStateRefreshed.emit({product: product});

                // 'Refreshed state product:', [product] );
            };

            
            product.displayProductDetails = () => {
                debugOff( 'Display "' + product.code + '" product details' );
                this._appService.displayProductDetailsModal( product );
            };

            
            product.getClone = () => {
                debugOff( 'Clone "' + product.code + '" product' );

                let clone: Product = Object.assign( {}, product );
                debugOff( 'Clone:', clone );

                return clone;
            };

            /** Refactor. Use the series field to sort the generators. Move sorting to another method.
             */
            product.getNameTags = () => {
                debugOff( 'Get "' + product.code + '" product name tags' );

                let basicGens = ['MS90EC1', 'MS150EC1', 'MS225EC1', 'MS400EC1', 'MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1'];
                let superGens = ['MX4EC1', 'MX5EC1', 'MX6EC1'];
                let currGenerator = this._catalogService._globals.selectedGenerator;

                let tags = '';
                

                
                    // TODO: Decouple, belongs to vspa app
                    // Return SUPER tag if product is dedicated for super generators

               

                   // if (product.code === 'iSPA_PACKAGE') {

                        // TODO: <!><!><!> Update in databse
                        // IDREAM exception
                    //    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                     //       product.vSpa.isSuperCompatible === true
                    //    ) {
                 //           tags += ' MAX';
                 //       }
    
              //      } 
               
               
                    if (product.code === 'IDREAM_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        tags += ' MAX';
                    }

                } 

                if (product.code === 'IBUTLER_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        tags += ' MAX';
                    }

                } 

                if (product.code === 'AIRBUTLER_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        tags += ' MAX';
                    }

                } 

                if (product.code === 'BUTLER_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        tags += ' MAX';
                    }

                } 

                if (product.code === 'ITEMPO_PLUS_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                       // tags += ' 2';
                    }

                } 

                if (product.code === 'ITEMPO_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                       // tags += ' 2';
                    }

                } 

                if (product.code === 'AIRTEMPO_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                       // tags += ' 2';
                    }

                } 

                if (product.code === 'ISTEAM_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                      //  tags += ' 2';
                    }

                } 

                    else {

                    // Normal behavior
                    if (superGens.indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        //tags += ' 2';
                    }
                }

                
                return tags;
            };

            //Summary

            product.getNameTagsSummary = () => {
                debugOff( 'Get "' + product.code + '" product name tags' );

                let basicGens = ['MS90EC1', 'MS150EC1', 'MS225EC1', 'MS400EC1', 'MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1'];
                let superGens = ['MX4EC1', 'MX5EC1', 'MX6EC1'];
                let currGenerator = this._catalogService._globals.selectedGenerator;

                let tags = '';
                
                    // TODO: Decouple, belongs to vspa app
                    // Return SUPER tag if product is dedicated for super generators

                if (product.code === 'IDREAM_PACKAGE') {

                    // TODO: <!><!><!> Update in databse
                    // IDREAM exception
                    if (['MX4EC1', 'MX5EC1', 'MX6EC1'].indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        //tags += ' 2';
                    }

                }

                
                
                
                else {

                    // Normal behavior
                    if (superGens.indexOf( currGenerator ) !== -1 &&
                        product.vSpa.isSuperCompatible === true
                    ) {
                        //tags += ' 2';
                    }
                }


                return tags;
            };

            
            // TODO: Does not work properly, returns with category null
            product.getSceneImage = () => {
                debugOff( 'Get "' + product.code + '" product scene image' );

                let imagePath = null;

                if (product.images.scene !== null) {
                    imagePath = self._imgPaths.products + product.images.folder + 'scene/' + product.images.scene;
                }

                debugOff( 'Image path:', imagePath );

                return imagePath;
            };

            /** Methods mirrors arbitrary properties from sourceProduct to current product.
             * Params that specify what properties to sync
             * Uses cloning instead of referencing in order to prevent data thrashing accidents
             */
            product.syncWithProduct = (sourceProduct: Product, properties: Array<any>) => {
                debugOff( 'Sync "' + product.code + '" product with "' + sourceProduct.code + '" target product' );

                properties.forEach( property => {

                    // If it is object make a clone
                    // if (sourceProduct[property] === Object( sourceProduct[property] )) {
                    //
                    //     // <!> Several fringe cases could miss-fire, arrays, functions, constructors, etc
                    //     product[property] = Object.assign( {}, sourceProduct[property]);
                    // } else {
                        product[property] = sourceProduct[property];
                                    // // '--- "' + sourceProduct.id + '.' + property + '" - Source:', sourceProduct[property] );
                                    // // '--- "' + product.code + '.' + property + '" - Value:', product[property] );
                                    // // 'Synced product:', product );
                    // }

                });

            };

            // TODO: reenable method
            // product.checkIfRequires = targetProduct => {
            //
            //     // Skip redundant checks
            //     if (product.isRequiringOtherProds === false ||
            //         product.code === targetProduct.id
            //     ) { return false; }
            //
            //     for (var i = 0; i < product.isRequiring.length; i++) {
            //         if (product.isRequiring[i].id === targetProduct.id) {
            //             return true;
            //         }
            //     }
            //
            //     return false;
            // };

            // TODO: reenable method
            // product.checkIfExcludes = targetProduct => {
            //
            //     // Skip redundant checks
            //     if (product.isExcludingOtherProds === false ||
            //         product.code === targetProduct.id
            //     ) { return false; }
            //
            //     for (var i = 0; i < product.isExcluding.length; i++) {
            //         if (product.isExcluding[i].id === targetProduct.id) {
            //             return true;
            //         }
            //     }
            //
            //     return false;
            // };

            // TODO: reenable method
            // product.checkIfIsRequiredBy = targetProduct => {
            //
            //     // Skip redundant checks
            //     if (product.isRequiredByOtherProds === false ||
            //         product.code === targetProduct.id
            //     ) {return false;}
            //
            //     for (var i = 0; i < product.isRequiredBy.length; i++) {
            //         if (product.isRequiredBy[i].id === targetProduct.id) {
            //             return true;
            //         }
            //     }
            //
            //     return false;
            // };

            // TODO: reenable method
            // product.checkIfIsExcludedBy = targetProduct => {
            //
            //     // Skip redundant checks
            //     if (product.isExcludedByOtherProds === false ||
            //         product.code === targetProduct.id
            //     ) { return false; }
            //
            //     for (var i = 0; i < product.isExcludedBy.length; i++) {
            //         if (product.isExcludedBy[i].id === targetProduct.id) {
            //             return true;
            //         }
            //     }
            //
            //     return false;
            // };

        });
    }

    
    private _handleError (error: Response) {
        console.error( error );
        return Observable.throw( error.json().error || 'Server error' );
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/products-service.ts